import React, { useEffect, useRef, useState } from 'react';

const ChatbotInput = (props: any) => {
  const { updatePrompt, updateInputCount } = props;

  const [message, setMessage] = useState('');
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const handleEnterKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (!message) return;
      const hiddenSubmitBtn = document.querySelector('#hidden-btn') as HTMLButtonElement;
      if (hiddenSubmitBtn) {
        hiddenSubmitBtn.click();
      }
      resetInputValues();
    }
  };

  const resetInputValues = () => {
    setMessage('');
    updateInputCount(0);
  };

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    let value = e.target.value;
    value = value.replace(/[<>]/g, '');
    setMessage(value);
    updatePrompt(value);
  };
  return (
    <>
      <textarea
        ref={textareaRef}
        value={message}
        className="react-chatbot-kit-chat-input border-none w-full bg-[#fff] resize-none p-[0.6rem] overflow-y-auto scrollbar-webkit"
        placeholder="Write your message (max 2,000 characters)"
        onChange={handleChange}
        maxLength={2000}
        onKeyDown={handleEnterKeyDown}
      ></textarea>
      <button
        className={`react-chatbot-kit-chat-btn-send px-4 py-4 bg-[#fff]`}
        onClick={resetInputValues}
        style={{ pointerEvents: !message ? 'none' : 'all' }}
      >
        <img src="/icons/paperplane.svg" alt="send" />
      </button>
    </>
  );
};

export default ChatbotInput;
